import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import { useModalContext } from 'ui-components/components/modal/context';

import { AddressPropType } from '../../../../prop-types/address';
import { ValidationAddressSelection } from './validation-address-selection';
import style from '../style.module.less';
import { messages } from '../messages';

export const ValidationErrorSelector = ({ billingAddress }) => {
  const { onClose } = useModalContext();
  return (
    <div className={style['validation-error']}>
      <Text textType={TextType.Description} value={messages.errorConfirmationQuestion} />
      <Text textType={TextType.Label} value={messages.enteredAddress} />
      <ValidationAddressSelection address={billingAddress} />
      <Button className={style['address-edit-button']} onClick={onClose} theme='link'>
        <FormattedMessage {...messages.editAddress} />
      </Button>
    </div>
  );
};

ValidationErrorSelector.propTypes = {
  billingAddress: AddressPropType.isRequired,
};
